import React from 'react';
import { motion } from 'framer-motion';
import './Logo.css';

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15, delayChildren: 0.05 } },
};

const markVariants = {
  hidden: { opacity: 0, scale: 0.5, rotate: -20 },
  visible: { opacity: 1, scale: 1, rotate: 0, transition: { type: 'spring', stiffness: 260, damping: 18 } },
};

const wordVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.35, ease: 'easeOut' } },
};

const roofVariants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: { pathLength: 1, opacity: 0.95, transition: { duration: 0.7, delay: 0.35, ease: 'easeOut' } },
};

const Logo = ({ compact = false, className = '' }) => (
  <motion.div className={`hd-logo ${className}`} variants={containerVariants} initial="hidden" animate="visible">
    <motion.div
      className="hd-logo-mark"
      variants={markVariants}
      whileHover={{ rotate: -8, scale: 1.08 }}
      transition={{ type: 'spring', stiffness: 320, damping: 14 }}
    >
      <svg viewBox="0 0 44 44" width="38" height="38" aria-hidden="true">
        <defs>
          <linearGradient id="hdLogoGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#d9a54a" />
            <stop offset="100%" stopColor="#7f5820" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="42" height="42" rx="13" fill="url(#hdLogoGrad)" />
        <motion.path
          d="M10.5 17 L22 8.5 L33.5 17"
          fill="none"
          stroke="#faf6ef"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={roofVariants}
        />
        <text
          x="22"
          y="31"
          textAnchor="middle"
          fontFamily="Georgia, 'Times New Roman', serif"
          fontSize="15"
          fontWeight="700"
          fill="#faf6ef"
        >
          HD
        </text>
      </svg>
    </motion.div>

    {!compact && (
      <motion.span className="hd-logo-word" variants={wordVariants}>
        <span className="hd-logo-word-home">Home</span>
        <span className="hd-logo-word-deco">Deco</span>
      </motion.span>
    )}
  </motion.div>
);

export default Logo;